import css from 'styled-jsx/css';

export default css`
  :global(.turnkey-header) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 22px;
  }

  :global(.turnkey-title-container) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  :global(.turnkey-title) {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.00636364em;
  }

  :global(.uppercase) {
    text-transform: uppercase;
  }

  :global(.turnkey-icon) {
    height: 41px;
    width: 49px;
    margin-top: 10px;
  }

  :global(.turnkey-buttons-container) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  :global(.turnkey-delete-button-container) {
    width: 136px;
    margin-right: 16px;
  }

  :global(.turnkey-save-button-container) {
    width: 96px;
  }

  :global(.turnkey-content) {
    width: 70%;
  }

  @media only screen and (max-width: 1024px) {
    :global(.turnkey-content) {
      width: 100%;
    }
  }

  :global(.turnkey-flex-row) {
    display: flex;
    flex-direction: row;
  }

  :global(.turnkey-domain) {
    justify-content: space-between;
    margin-top: 16px;
    margin-bottom: 25px;
  }

  @media only screen and (max-width: 425px) {
    :global(.turnkey-domain) {
      flex-direction: column;
      margin-top: 16px;
      margin-bottom: 25px;
    }
  }

  :global(.turnkey-domain-name-input) {
    display: flex;
    flex-direction: column;
    width: 50%;
    position: relative;
  }

  @media only screen and (max-width: 425px) {
    :global(.turnkey-domain-name-input) {
      width: 100%;
    }
  }

  :global(.turnkey-domain-name-container) {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  @media only screen and (max-width: 425px) {
    :global(.turnkey-domain-name-container) {
      margin-top: 16px;
    }
  }

  :global(.turnkey-domain-name-container input) {
    height: 50px !important;
    border-radius: 8px !important;
  }

  :global(.turnkey-domain-name-container label) {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: 0.00636364em;
  }

  :global(.turnkey-domains-list-item) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 50px;
    border: 1px solid #92a0ae;
    align-items: center;
    padding: 0 0.8rem;
  }

  @media only screen and (max-width: 425px) {
    :global(.turnkey-domains-list-item) {
      flex-direction: column;
      height: 64px;
      align-items: center;
      padding: 0.6rem 0;
    }
  }

  :global(.turnkey-domains-list-item:last-child) {
    border-top: 0;
  }

  :global(.turnkey-domain-text) {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    letter-spacing: 0.00636364em;
    color: #263c4b;
  }

  :global(.turnkey-domain-text-selected) {
    color: #37cc5c;
  }

  :global(.turnkey-domain-text-unavailable) {
    color: #ff3f35;
  }

  :global(.turnkey-domain-icon-container) {
    cursor: pointer;
  }

  :global(.turnkey-domain-selected-icon) {
    margin-left: 19px;
    color: #37cc5c;
  }

  :global(.turnkey-domain-available-icon) {
    margin-left: 19px;
    color: #263c4b;
  }

  :global(.turnkey-domain-unavailable-icon) {
    margin-left: 19px;
    color: #ff3f35;
  }

  :global(.discover .radio-group label) {
    margin: 8px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  :global(.discover .radio-group input) {
    margin-right: 16px;
  }

  :global(.turnkey-description) {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 25px;
    letter-spacing: 0.00636364em;
    color: var(--foreground);
  }

  :global(.turnkey-divider) {
    width: 100%;
    height: 1px;
    background-color: #d5d5d5;
    margin: 34px 0;
  }

  :global(.turnkey-language-currency-container) {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin-top: 12px;
  }

  @media only screen and (max-width: 425px) {
    :global(.turnkey-language-currency-container) {
      flex-direction: column;
    }
  }

  :global(.turnkey-select-container) {
    width: 48%;
  }

  @media only screen and (max-width: 425px) {
    :global(.turnkey-select-container) {
      width: 100%;
    }
  }

  :global(.turnkey-select-container .input-drop) {
    height: 50px !important;
    border-radius: 8px !important;
  }

  :global(.turnkey-select-container label) {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: 0.00636364em;
  }

  :global(.turnkey-templates-container) {
    margin-top: 28px;
  }

  :global(.carousel-container) {
    position: relative;
  }

  :global(.slider-container ul) {
    display: block !important;
  }

  :global(.carousel-slide img) {
    padding-right: 40px;
    margin-left: 20px;
  }

  :global(.slider-image) {
    display: block;
    width: 250px;
  }

  :global(.turnkey-template-description) {
    display: flex;
    flex-direction: column;
  }

  :global(.turnkey-template-title) {
    align-self: center;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.00636364em;
    margin: 10px 0;
  }

  :global(.turnkey-template-button) {
    margin: 0 20px;
  }

  :global(.turnkey-preview-container) {
    align-self: center;
    margin-top: 25px;
  }

  :global(.turnkey-save-settings) {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  @media only screen and (max-width: 425px) {
    :global(.turnkey-save-settings) {
      margin-top: 30px;
    }
  }

  :global(button.save-settings-button) {
    width: 190px;
  }

  :global(.turnkey-carousel-button) {
    position: absolute;
    background: var(--background-utils);
    width: 35px;
    top: 30%;
    height: 35px;
    border: solid thin var(--foreground);
  }

  :global(.turnkey-carousel-button-right) {
    right: -19px;
  }
  :global(.turnkey-carousel-button-left) {
    left: -19px;
  }

  :global(.turnkey-selected-template) {
    height: 40px;
    color: #37cc5c;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  :global(.turnkey-selected-template-text) {
    font-weight: 500;
    margin-left: 10px;
  }

  :global(.turnkey-selected-template-icon) {
    font-weight: 500;
    font-size: 30px !important;
  }
  .fixed-row {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: var(--background-utils);
    padding: 1em;
    box-shadow: -2px 0px 5px 1px rgba(0, 0, 0, 0.15);
  }
`;
